import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const clsPrefix = 'ui-action-card';

export const ActionCardSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.medium}px;
  transition-property: background-color, color;
  transition-duration: 0.2s;
  box-shadow: ${({ theme }) => theme.shadows.low};

  .${`${clsPrefix}-content`} {
    flex: 1;
    justify-content: center;

    padding-top: 16px;
    padding-bottom: 16px;
    margin-left: 16px;
    margin-right: 24px;

    .${clsPrefix}-has-left& {
      margin-left: 0px;
    }

    .${clsPrefix}-has-right&, .${clsPrefix}-done&, .${clsPrefix}-onHold&, .${clsPrefix}-error& {
      margin-right: 0px;
    }
  }

  &.${clsPrefix}-on-background {
    background-color: ${({ theme }) => theme.color.surface.baseline};
  }

  &,
  &.${clsPrefix}-on-baseline {
    background-color: ${({ theme }) => theme.color.surface.background};
  }

  &.${clsPrefix}-ghost {
    background-color: transparent;
    box-shadow: none;
  }

  &.${clsPrefix}-done {
    color: ${({ theme }) => theme.color.tint.success};
    background-color: ${({ theme }) => theme.color.surface.success};
  }

  &.${clsPrefix}-onHold {
    color: ${({ theme }) => theme.color.tint.success};
    background-color: ${({ theme }) => theme.color.surface.info};
  }
`;

const getWrapperStyle = (state: 'ripple' | 'hover' | 'focused') => css`
  &.${clsPrefix}-on-background {
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.baseline, state, 'light')};
  }

  &,
  &.${clsPrefix}-on-baseline {
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.background, state, 'light')};
  }

  &.${clsPrefix}-ghost {
    background-color: ${({ theme }) => theme.createOverlayColor('transparent', state)};
  }

  &.${clsPrefix}-done {
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.success, state)};
  }

  &.${clsPrefix}-onHold {
    background-color: ${({ theme }) => theme.createOverlayColor(theme.color.surface.info, state)};
  }
`;

export const ActionButton = styled.button`
  all: unset;
  width: 100%;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    ${ActionCardSC} {
      ${getWrapperStyle('hover')};
    }
  }

  &:focus:not(:disabled) {
    ${ActionCardSC} {
      ${getWrapperStyle('focused')};
    }
    outline: none;
  }

  &:active:not(:disabled) {
    ${ActionCardSC} {
      ${getWrapperStyle('ripple')};
    }
  }
`;

export const ActionLink = styled(Link)`
  all: unset;
  text-decoration: none;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    text-decoration: none;
    ${ActionCardSC} {
      ${getWrapperStyle('hover')};
    }
  }

  &:focus:not(:disabled) {
    text-decoration: none;
    ${ActionCardSC} {
      ${getWrapperStyle('focused')};
    }
    outline: none;
  }

  &:active:not(:disabled) {
    text-decoration: none;
    ${ActionCardSC} {
      ${getWrapperStyle('ripple')};
    }
  }
`;
